module.exports = __webpack_public_path__ + "img/question6.969c269e.png";